<script>
import { HorizontalBar} from "vue-chartjs";
import { mapState } from "vuex";
import ClientsService from "@/services/ClientsService";
import EventBus from "@/main.js";
import { ATTR_MAP, addSign, fixName, BAR_CHART_MIN, BAR_CHART_MAX, BUSINESS, 
SPORTS, SCHOOL, SD, WEAK, STRONG, WEAK_COLOR, AVERAGE_COLOR, AVERAGE_COLOR_POS, 
AVERAGE_COLOR_NEG, STRONG_COLOR, ATTR_LIST_R, ATTR_LIST_B, ATTR_LIST_RSMP } from "@/components/globals/consts.js";
import ChartDataLabels from 'chartjs-plugin-datalabels'
//const { reactiveProp } = mixins;
export default {
  extends: HorizontalBar,
  // mixins: [reactiveProp],
  props: {
    allClientAttrs: {
      type: [Object],
      required: true,
      default: null
    },
    clientName: {
      type: String,
      required: true,
      default: null
    }
  },
  data() {
    return {
      valueList: [],
      absValueList: [],
    //  nodeList: [],
      standardGraph: true,
      scoresNotDisplayed: true,
      alphabetical: true,
	    attrList: [],
      checkedAttrs: [],
      min: BAR_CHART_MIN,
      regScale: 0, /// ELSE -2.04
      firstRun: true,
      wAttrs: [],
			aAttrs: [],
			sAttrs: [],
      //clientName: null
    }
  },
  computed: {
    ...mapState(["isUserLoggedIn", "user", "route", "testType"])
  },
  beforeDestroy() {
    try {
      this._chart = null;

 console.log('destroying.....')

      //this.valueList.destroy()
      this.absValueList = []
      this.attrList = []
      this.checkedAttrs = []
      this.wAttrs = []
      this.aAttrs = []
      this.sAttrs = []
      //delete this._chart;
      this._chart = null
     
    } catch (err) {
      console.log(err);
    }
  },
  created() {
    if (this.firstRun) {
      if (this.testType === BUSINESS || this.testType === SPORTS || this.testType === SCHOOL) { 
        this.checkedAttrs = ATTR_LIST_B
      }
      else if (this.testType === SD) {
        this.checkedAttrs = ATTR_LIST_R
      }
      // else if (this.testType === SCHOOL ){
      //   this.checkedAttrs = ATTR_LIST_B
      //      //     this.checkedAttrs = ATTR_LIST_RSMP

      // }
      this.firstRun = false
    }
  },
  async mounted() {

    await EventBus.$on("barCheckedAttrs", attrList => {
     if (JSON.stringify(attrList) !== JSON.stringify(this.checkedAttrs)) {
      this.checkedAttrs = attrList
      this.attrList = attrList
      this.renderBarChart();
     }
    })

    await EventBus.$on("toggleBarGraphType", value => {
      this.standardGraph = value
      this.standardGraph ? this.min = BAR_CHART_MIN : this.min = 0
      this.renderBarChart()
      // delete value

      })
    await EventBus.$on("toggleBarScores", value => {
      this.scoresNotDisplayed = value
      this.renderBarChart()
      // delete value
      })

    await EventBus.$on("toggleBarNeedsOrder", value => {
      this.alphabetical = value
      this.renderBarChart()
      // delete value
    })
    await this.renderBarChart()
  }
  ,
  methods: {
    
    async renderBarChart()  {
      try {
        var that = this
        let tempNodeList = []
        let nodeList = []
        let nodeListW = []
        let nodeListA = []
        let nodeListS = []
        let standardGraph = this.standardGraph
        let alphabetical = this.alphabetical
        let scoresNotDisplayed = this.scoresNotDisplayed 
        let min = this.min
        let attrList = this.attrList
        let tempCheckedAttrs = this.checkedAttrs
        let tempAllClientAttrs = this.allClientAttrs // await JSON.parse(JSON.stringify(this.allClientAttrs))
        
          //if (tempCheckedAttrs != null) {
          await Object.entries(tempAllClientAttrs).forEach(([key, value]) => {
            let attrDict = {};
            if (key.length === 3 && value !== null && value !== undefined) {
              attrDict.attr = ATTR_MAP[key]
              if (tempCheckedAttrs.includes(attrDict.attr)) {      
                  if (value == 0.00 && this.scoresNotDisplayed === true) {
                    attrDict.isZero = 1
                    attrDict.value = 0.01
                    attrDict.absValue = 0.01
                  } else {
                    attrDict.value = addSign(+value)
                    attrDict.absValue = Math.abs(attrDict.value)
                }
                tempNodeList.push(attrDict)
                if (attrDict.value < WEAK) {
                  nodeListW.push(attrDict)
                } else if (attrDict.value > STRONG) {
                  nodeListS.push(attrDict)
                } else {
                  nodeListA.push(attrDict)
                }
                nodeList.push(attrDict)														        
              }
            }
          })
          this.wAttrs = nodeListW
          this.aAttrs = nodeListA
          this.sAttrs = nodeListS

          if (!alphabetical) { 
            tempNodeList = tempNodeList.sort(this.orderAbsValue)  
          } 
          for (let x in Object.entries(tempNodeList)) {
            this.attrList[x] = tempNodeList[x].attr
            this.valueList[x] = addSign(tempNodeList[x].value) 
            this.absValueList[x] = tempNodeList[x].absValue
          }
          this.absValueList = this.absValueList.slice(0,tempCheckedAttrs.length)
          this.valueList = this.valueList.map((a) => addSign(a))
          this.valueList = this.valueList.slice(0,tempCheckedAttrs.length) 

        let colors = this.valueList.map(function(value) {
          if (value < WEAK) { return WEAK_COLOR } 
          else if (value > STRONG) { return STRONG_COLOR } 
          else if (value > 0) { return AVERAGE_COLOR_POS } 
          else {return AVERAGE_COLOR_NEG }
        })
      //  }
      let options = {
        plugins: {
          datalabels: { 
            display: !scoresNotDisplayed,
            align: function (context)  { 
              if (context != null) {
                var index = context.dataIndex
                var value = context.dataset.data[index]
                if (value < 0) return 'start'
                if (value >= 0) return 'end'
              }
            },
            offset: 2, 
            anchor: function (context)  {
              if (context != null) {
              var index = context.dataIndex
              var value = context.dataset.data[index]
              if (value < 0) return 'start'
              if (value >= 0) return 'end'
              }
            }, 
            formatter: function (value, context) {
              if (context != null && value != null) {
              let color = context.dataset.backgroundColor[context.dataIndex]
              if (color === WEAK_COLOR || color === AVERAGE_COLOR_NEG) {
                let tValue = +value
                if (value > 0) { tValue = -tValue }
                return addSign(tValue)
              } else if (color === AVERAGE_COLOR_POS ||color === STRONG_COLOR) {
                return addSign(+value)
              }
            }
          }
          }
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: function(tooltipItems, data) {
              let value = data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]
              return value
            }
          }
        },
        legend: {
          display: false,
          position: 'bottom'
        },
        scales: {
          xAxes: [
            {
              //labels: ['Weak', 'Average', 'Strong'],
              type: 'linear',
              position: 'bottom',
              ticks: {
                fontFamily: "'Arial',sans-serif",
                fontSize: 14,
                fontColor: "black",
                display: true,
                max: BAR_CHART_MAX,
                min: this.min,
                stepSize: 0.17,
                suggestedMin: this.min,
                suggestedMax: BAR_CHART_MAX,
                autoSkip: false,
                maxRotation: 0,
                callback: function(value, index, values) {   
                  if (value === 0.85 && !standardGraph) { return '' } 
                  else if (value === 0.85 && standardGraph) { return '' } 
                  else if (value === 0.00) { return '0.00' } 
                  else if (value === -0.85 && standardGraph) { return '' } 
                  else if (value === BAR_CHART_MAX) { return '' }
                }
              },
               // end ticks
              barThickness: 6,
              maxBarThickness: 6,
              gridLines: {
                zeroLineWidth: 0,
                autoSkip: false,
                display: function(value, index, values) {
                  if (
                    value === 0.85 ||
                    value === -0.85 ||
                    value === 0.00 ||
                    value === BAR_CHART_MAX ||
                    value === BAR_CHART_MIN
                  ) { return true }
                }
              } 
            }, // end x-axis
          ],
          yAxes: [
            {
              //type: "category",
              labels: this.attrList,
              position: 'left',
              display: true,
              fontColor: "black",
              fontFamily: "'Arial'",
              fontSize: 14,
              gridLines: {
                zeroLineWidth: 0,
                display: false
              },
              scaleLabel: {
                display: true,
                labelString: 'Basic Desire',
                fontColor: 'black',
                fontSize: 20,
                fontFamily: 'Arial',
                fontWeight: 'bold'
              }
            }
          ]
        }
      }
      let datacollection = {
        datasets: [
          {
            borderColor: "black",
            backgroundColor: colors,
            data: that.getData()
          }
        ],
        labels: ['Weak', 'Average', 'Strong']      
      }
        await this.renderChart(datacollection, options)
    } catch (e) {
      console.log(e)
    }
  },
    getData: function () {
      if (this.standardGraph)  {
        return this.valueList
      } else { 
        return this.absValueList
      }
    },
   orderAbsValue (a, b) {
    if (Math.abs(a.value) > Math.abs(b.value)) {
      return -1
    } else if (Math.abs(a.value) < Math.abs(b.value)) {
      return 1
    }
      return 0
    },
    getDataLabels () {
      let datalabels = {
        align: function (context) {
          
          if (context != null) {
          var index = context.dataIndex
          var value = context.dataset.data[index]
          if (value < 0) {
            return 'center'
          } else { 
            return 'left'
          }
          }
        },
        offset: function (context) {
          if (context != null) {
            var index = context.dataIndex
            var value = context.dataset.data[index]  
            if (value < 0) { return 60 } 
            else if (value == 0.00) { return -100 }
            else { return -50 }
          }
        },
        color: this.displayLabels
      }
            
      if (this.scoresNotDisplayed) {
        return null
      } else { 
        return datalabels
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ViewClient/VueBarChart.vue